export const NATIVE_OAUTH_SCHEME = 'rintintin';
export const NATIVE_OAUTH_HOST = 'open';

export type NativeOAuthCallbackPath = '/auth/google/callback';

export function buildNativeOAuthDeepLink(
  path: NativeOAuthCallbackPath,
  search: string
): string {
  const trimmed = search.trim();
  const query =
    trimmed === '' || trimmed.startsWith('?') ? trimmed : `?${trimmed}`;
  return `${NATIVE_OAUTH_SCHEME}://${NATIVE_OAUTH_HOST}${path}${query}`;
}

export function shouldBounceOAuthCallbackToNativeApp(input: {
  userAgent: string;
  isNativeApp: boolean;
}): boolean {
  if (input.isNativeApp) {
    return false;
  }
  return /iPhone|iPad|iPod|Android/i.test(input.userAgent);
}

/** Google auth codes are single-use: do not exchange in Safari if the app took over. */
export function shouldSkipWebOAuthAfterNativeBounce(
  visibilityState: string,
  nativeClientRequested = false
): boolean {
  if (nativeClientRequested) return true;
  return visibilityState === 'hidden';
}

export function parseNativeOAuthCallbackSearch(rawUrl: string): string | null {
  try {
    const url = new URL(rawUrl);
    if (!url.pathname.includes('/auth/google/callback')) return null;
    return url.search;
  } catch {
    return null;
  }
}

function decodeJwtPayload(state: string): Record<string, unknown> | null {
  const parts = state.split('.');
  if (parts.length < 2) return null;
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    return JSON.parse(atob(padded)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

/** State OAuth signé : `rintintin_client: native` (démarrage depuis l’app Capacitor). */
export function oauthStateRequestsNativeClient(
  state: string | null | undefined
): boolean {
  if (!state) return false;
  const payload = decodeJwtPayload(state);
  if (!payload) return false;
  return String(payload.rintintin_client || '').trim().toLowerCase() === 'native';
}
